import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=20d0add0&scoped=true&"
import script from "./platforms.vue?vue&type=script&lang=js&"
export * from "./platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0add0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d0add0')) {
      api.createRecord('20d0add0', component.options)
    } else {
      api.reload('20d0add0', component.options)
    }
    module.hot.accept("./platforms.vue?vue&type=template&id=20d0add0&scoped=true&", function () {
      api.rerender('20d0add0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/platforms.vue"
export default component.exports